import { Circle, Fill, Style, Stroke, Text } from "ol/style";

import colorsRepository from "./colors-repository";

let index = 0;

// tried cloning Circle, but then image ended up being null!
const styleGenerator = () => {
	return new Style({
		image: new Circle({
			radius: 3.2,
			fill: new Fill({ color: colorsRepository.pointOffset[index++] }),
		})
	});
};

/**
 * We will make an object full of styles, made with array of colors defined in colors repository.
 * So depending on the need you either go directly for OpenLayers style or just a color (rgb text)
 *
 * Color array must be length of 43 colors in order for this to not trigger error.
 * Since we want colors for explicitly requested
 * => Before even smallest value of -20
 * => negative values [-20 ... -1]
 * => the zero value itself
 * => positive values [1 ... 20]
 * => obviously for even more than value of 20
 * So in total 43 colors in repository thus 43 styles.
 */
const pointStyle = {
	lessThanMinimal: styleGenerator(),
	n20: styleGenerator(),
	n19: styleGenerator(),
	n18: styleGenerator(),
	n17: styleGenerator(),
	n16: styleGenerator(),
	n15: styleGenerator(),
	n14: styleGenerator(),
	n13: styleGenerator(),
	n12: styleGenerator(),
	n11: styleGenerator(),
	n10: styleGenerator(),
	n9: styleGenerator(),
	n8: styleGenerator(),
	n7: styleGenerator(),
	n6: styleGenerator(),
	n5: styleGenerator(),
	n4: styleGenerator(),
	n3: styleGenerator(),
	n2: styleGenerator(),
	n1: styleGenerator(),
	zero: styleGenerator(),
	p1: styleGenerator(),
	p2: styleGenerator(),
	p3: styleGenerator(),
	p4: styleGenerator(),
	p5: styleGenerator(),
	p6: styleGenerator(),
	p7: styleGenerator(),
	p8: styleGenerator(),
	p9: styleGenerator(),
	p10: styleGenerator(),
	p11: styleGenerator(),
	p12: styleGenerator(),
	p13: styleGenerator(),
	p14: styleGenerator(),
	p15: styleGenerator(),
	p16: styleGenerator(),
	p17: styleGenerator(),
	p18: styleGenerator(),
	p19: styleGenerator(),
	p20: styleGenerator(),
	overMaximum: styleGenerator()
};

const offsetStyleMethod = (mapElement) => {
	if (!mapElement || !mapElement.get) return null;

	const meanAnnualOffset = mapElement.get("meanAnnualOffset");

	// lets connect negative values to style objects
	if (meanAnnualOffset <= -20.5) return pointStyle.lessThanMinimal;
	if (meanAnnualOffset <= -19.5) return pointStyle.n20;
	if (meanAnnualOffset <= -18.5) return pointStyle.n19;
	if (meanAnnualOffset <= -17.5) return pointStyle.n18;
	if (meanAnnualOffset <= -16.5) return pointStyle.n17;
	if (meanAnnualOffset <= -15.5) return pointStyle.n16;
	if (meanAnnualOffset <= -14.5) return pointStyle.n15;
	if (meanAnnualOffset <= -13.5) return pointStyle.n14;
	if (meanAnnualOffset <= -12.5) return pointStyle.n13;
	if (meanAnnualOffset <= -11.5) return pointStyle.n12;
	if (meanAnnualOffset <= -10.5) return pointStyle.n11;
	if (meanAnnualOffset <= -9.5) return pointStyle.n10;
	if (meanAnnualOffset <= -8.5) return pointStyle.n9;
	if (meanAnnualOffset <= -7.5) return pointStyle.n8;
	if (meanAnnualOffset <= -6.5) return pointStyle.n7;
	if (meanAnnualOffset <= -5.5) return pointStyle.n6;
	if (meanAnnualOffset <= -4.5) return pointStyle.n5;
	if (meanAnnualOffset <= -3.5) return pointStyle.n4;
	if (meanAnnualOffset <= -2.5) return pointStyle.n3;
	if (meanAnnualOffset <= -1.5) return pointStyle.n2;
	if (meanAnnualOffset <= -0.5) return pointStyle.n1;

	// and now for positive values
	if (meanAnnualOffset >= 20.5) return pointStyle.overMaximum;
	if (meanAnnualOffset >= 19.5) return pointStyle.p20;
	if (meanAnnualOffset >= 18.5) return pointStyle.p19;
	if (meanAnnualOffset >= 17.5) return pointStyle.p18;
	if (meanAnnualOffset >= 16.5) return pointStyle.p17;
	if (meanAnnualOffset >= 15.5) return pointStyle.p16;
	if (meanAnnualOffset >= 14.5) return pointStyle.p15;
	if (meanAnnualOffset >= 13.5) return pointStyle.p14;
	if (meanAnnualOffset >= 12.5) return pointStyle.p13;
	if (meanAnnualOffset >= 11.5) return pointStyle.p12;
	if (meanAnnualOffset >= 10.5) return pointStyle.p11;
	if (meanAnnualOffset >= 9.5) return pointStyle.p10;
	if (meanAnnualOffset >= 8.5) return pointStyle.p9;
	if (meanAnnualOffset >= 7.5) return pointStyle.p8;
	if (meanAnnualOffset >= 6.5) return pointStyle.p7;
	if (meanAnnualOffset >= 5.5) return pointStyle.p6;
	if (meanAnnualOffset >= 4.5) return pointStyle.p5;
	if (meanAnnualOffset >= 3.5) return pointStyle.p4;
	if (meanAnnualOffset >= 2.5) return pointStyle.p3;
	if (meanAnnualOffset >= 1.5) return pointStyle.p2;
	if (meanAnnualOffset >= 0.5) return pointStyle.p1;

	return pointStyle.zero;
}


const activityStylesRepository = {
	none: new Style({
		fill: new Fill({ color: colorsRepository.activityLevel.none }),
		stroke: new Stroke({ color: colorsRepository.activityEdge, width: 1 })
	}),
	low: new Style({
		fill: new Fill({ color: colorsRepository.activityLevel.low }),
		stroke: new Stroke({ color: colorsRepository.activityEdge, width: 1 })
	}),
	medium: new Style({
		fill: new Fill({ color: colorsRepository.activityLevel.medium }),
		stroke: new Stroke({ color: colorsRepository.activityEdge, width: 1 })
	}),
	high: new Style({
		fill: new Fill({ color: colorsRepository.activityLevel.high }),
		stroke: new Stroke({ color: colorsRepository.activityEdge, width: 1 })
	}),
	default: new Style({
		fill: new Fill({ color: colorsRepository.activityLevel.default }),
		stroke: new Stroke({ color: colorsRepository.activityEdge, width: 1 })
	})
};

/** NOPE NOPE NOPE JUST NOPE ... I made this to export clear OBJECTS not partials man ... so fail. */

const activityStyleMethod = (mapElement) => {
	if (!mapElement || !mapElement.get) return [];

	const activityLevel = mapElement.get("activity");

	switch (activityLevel) {
		case 1: return activityStylesRepository.none;
		case 2: return activityStylesRepository.low;
		case 3: return activityStylesRepository.medium;
		case 4: return activityStylesRepository.high;
		default: return activityStylesRepository.default;
	}
};


const selectBorderBase = new Stroke({
	color: "white",
	width: 5, // base 5px white line, but over it
});


const selectBorderCore = new Stroke({
	color: "blue", // [0, 153, 255, 1]
	width: 3, // is 3px blue "core"
});

const selectedActivityRepository = {
	none: [
		new Style({
			fill: new Fill({ color: colorsRepository.activityLevel.none }),
			stroke: selectBorderBase
		}),
		new Style({
			stroke: selectBorderCore,
			zIndex: Infinity
		})
	],
	low: [
		new Style({
			fill: new Fill({ color: colorsRepository.activityLevel.low }),
			stroke: selectBorderBase
		}),
		new Style({
			stroke: selectBorderCore,
			zIndex: Infinity
		})
	],
	medium: [
		new Style({
			fill: new Fill({ color: colorsRepository.activityLevel.medium }),
			stroke: selectBorderBase
		}),
		new Style({
			stroke: selectBorderCore,
			zIndex: Infinity
		})
	],
	high: [
		new Style({
			fill: new Fill({ color: colorsRepository.activityLevel.high }),
			stroke: selectBorderBase
		}),
		new Style({
			stroke: selectBorderCore,
			zIndex: Infinity
		})
	],
	default: [
		new Style({
			fill: new Fill({ color: colorsRepository.activityLevel.default }),
			stroke: new Stroke({ color: colorsRepository.activityEdge, width: 4 })
		}),
		new Style({
			stroke: selectBorderCore,
			zIndex: Infinity
		})
	]
};


const selectedActivityMethod = (mapElement) => {
	if (!mapElement || !mapElement.get) return [];

	const activityLevel = mapElement.get("activity");

	switch (activityLevel) {
		case 1: return selectedActivityRepository.none;
		case 2: return selectedActivityRepository.low;
		case 3: return selectedActivityRepository.medium;
		case 4: return selectedActivityRepository.high;
		default: return selectedActivityRepository.default;
	}
};


const blackBorder = new Stroke({ color: "black", width: 2 });
const whiteFont = new Fill({ color: "white" });

const areaTitleText = new Text({
	overflow: true,
	stroke: blackBorder,
	fill: whiteFont,
	text: "x",
	scale: 1.6,
	offsetY: -14
});

// technically there is no "shadows", but there are arrays of styles :) F*kin noobs
const areaShadow = new Style({
	stroke: new Stroke({ color: "rgba(128, 128, 128, 0.5)", width: 6 })
});

const areaPrimaryStyle = new Style({
	stroke: blackBorder,
	fill: new Fill({ color: "rgba(255, 255, 255, 0.2)" }),
	text: areaTitleText
});

const areaStyle = (feature) => {
	if (feature && feature.get){
		areaTitleText.setText(feature.get("title"));
	}

	return [areaShadow, areaPrimaryStyle];
};


export default {
	sensorStyle: offsetStyleMethod,
	activityStyle: activityStyleMethod,
	selectStyle: selectedActivityMethod,
	areaStyle: areaStyle
};
